import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskChangeCalendarRoute: InvariantJiraRoute = {
	name: 'servicedesk-change-calendar',
	path: '/jira/servicedesk/projects/:projectKey/change-calendar',
	exact: true,
};
